import { CylinderGeometry, Mesh, MeshBasicMaterial } from 'three';

import { IMeshOptions } from '@/types';

type Cylinder3dData = [number, number, number, number, number, number];

export class Cylinder3d {
  static create(data: Cylinder3dData, options: Partial<IMeshOptions>) {
    const [x, y, z, radiusTop, radiusBottom, height] = data;
    const { color = '#ffffff' } = options;

    const geometry = new CylinderGeometry(radiusTop, radiusBottom, height, 32);
    const material = new MeshBasicMaterial({ color });
    const cylinder = new Mesh(geometry, material);

    cylinder.position.set(x, y, z);
    cylinder.userData = { ...options };

    return cylinder;
  }
}
